import styled from 'styled-components'

export const StatistiqueItem = styled.div`
text-align: center;
border: 1px solid #efefef;
margin-bottom: 20px;
    padding: 15px;
display: flex;
flex-direction: column;
background-color: white;
box-shadow: 3px 3px 8px 0px rgb(145 145 145 / 10%) !important;
`;

export const ItemIcon = styled.div`
background-color: white;
img {
    width: 60px;
    height: 60px;
}
`;
export const ItemText = styled.div`
margin-top: 12px;
h5{
    font-size: 20px;
    color: #6c757d!important;
    font-weight: 600;
    margin-top: 10px;
}
h4{
    font-weight: 800;
    margin-top: 10px;
    color: #000000a1;
}
`;
